// extracted by mini-css-extract-plugin
export default {"tx":"fb07ecff1e","line":"fd67e3b04e"};